import script from "./ExamResult.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExamResult.vue?vue&type=script&setup=true&lang=ts"

import "./ExamResult.vue?vue&type=style&index=0&id=66d73f62&lang=scss&scoped=true"
import "./ExamResult.vue?vue&type=style&index=1&id=66d73f62&lang=scss"
import "./ExamResult.vue?vue&type=style&index=2&id=66d73f62&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66d73f62"]])

export default __exports__